import { useNavigationContext } from '../../../contexts/NavigationContext';
import ProjectPage from './Project/ProjectPage';
import MainLayout from '../../../components/Display/MainLayout';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <MainLayout scope={'collectifnode'} websiteLabel={"collectifnode.fr"}>
      <ProjectPage isActive={navigationContext.activeAppKey === 'cnproject'} />
    </MainLayout>
  );
}

export default Home;
